import React from 'react';

import { Modal } from 'components/Modal';

const getModalContent = (cost) => `
<p>Per Calix RMA Policy, there is a ${cost} Advanced Exchange Fee per unit. By selecting this box, you are confirming that you approve this fee. Please note, by approving this ${cost} ADVANCE EXCHANGE FEE, you are hereby stating that as an employee/agent of your Organization you agree to the following:</p>
<ol>
  <li>You are authorized to approve this fee and will provide a valid PO Number to be used for these charges.</li><br />
  <li>Upon receiving the Advance Replacement unit, you will return the failed unit to Calix ASAP so we may credit your account accordingly.</li><br />
  <li>If the failed unit is not returned to Calix within 30 days of your receipt of the Advance Replacement unit, your Organization will be invoiced for the Advance Replacement unit at Calix Standard List Price.</li>
</ol>
`;

const AdvanceExchangeModal = ({ cost, onClose, onConfirmation, ...props }) => {
  return (
    <Modal
      title="Advance Exchange"
      content={getModalContent(cost)}
      maxWidth="md"
      onConfirmation={onConfirmation}
      onDismiss={onClose}
      onCancel={onClose}
      confirmButtonText="ACCEPT"
      {...props}
    />
  );
};

export { AdvanceExchangeModal };
